import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'compactAmount',
  standalone: true,
})
export class CompactAmountPipe implements PipeTransform {
  transform(value: number, currency: string = '€'): string {
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(1).replace('.', ',').replace(',0', '')} M${currency}`;
    } else if (value >= 1000) {
      return `${(value / 1000).toFixed(1).replace('.', ',').replace(',0', '')} k${currency}`;
    } else {
      return `${value}${currency}`;
    }
  }
}
